import React from 'react';

const Contact = () => {
  return (
    <div
      name='Contact'
      className='w-full bg-gradient-to-b from-gray-800 to-black text-white md:h-screen'
    >
      <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 border-gray-500'>
            Contact
          </p>
          <p className='py-6'>Submit the form below to get in touch with me</p>
        </div>

        <div className='flex justify-center items-center'>
          <form action='https://getform.io/f/e7322007-d216-4bbf-ac89-8dee91d22217' method='POST' className='flex flex-col w-full md:w-1/2'>
            <input
              className='p-2 bg-transparent border-2 rounded-md text-white focus:outline-none'
              type='text'
              name='name'
              placeholder='Enter your name'
            />
            <input
              className='p-2 my-4 bg-transparent border-2 rounded-md text-white focus:outline-none'
              type='text'
              name='email'
              placeholder='Enter your email'
            />
            <textarea
              className='p-2 bg-transparent border-2 rounded-md text-white focus:outline-none'
              name='message'
              rows='10'
              placeholder='Enter your message'
            ></textarea>

            <button className='text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300'>
              Let's talk
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
